<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
    <div>
        <nav-bar />

        <div class="compilance-wrapper">
            <div class="container-fluid">
                <div class="row">
                    <contractor-details></contractor-details>
                    <contractor-documents></contractor-documents>
                </div>
            </div>

        </div>
    </div>
</b-overlay>
</template>

<script>
import NavBar from "@frontend/pages/manager/includes/NavBar.vue";
import ContractorDetails from '@frontend/pages/manager/contacts/Contractors/view/ContractorDetails.vue';
import ContractorDocuments from '@frontend/pages/manager/contacts/Contractors/view/ContractorDocuments/Index.vue';

export default {
    components: {
        NavBar,
        ContractorDetails,
        ContractorDocuments,
    },
    data() {
        return {
            // dashboardData: {}
        };
    },
    mounted() {
        // this.refreshDashboard();
    },
    methods: {}
};
</script>
